module.exports = __webpack_public_path__ + "img/ic_analytic.45d5d76e.svg";